var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "snippet-network" }, [
    _c("div", { staticClass: "image" }, [
      _vm.imageUrlDefault || _vm.imageUrl
        ? _c("img", { attrs: { src: _vm.imageUrlDefault || _vm.imageUrl } })
        : _c("img", {
            attrs: {
              src: require("@/assets/img/localhost-file-not-found.jpg"),
            },
          }),
    ]),
    _c("div", { staticClass: "content" }, [
      _vm.domaineDefault || _vm.domaine
        ? _c("p", { staticClass: "domaine" }, [
            _vm._v(_vm._s(_vm.domaineDefault || _vm.domaine)),
          ])
        : _vm._e(),
      _vm.titleDefault || _vm.title
        ? _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.titleDefault || _vm.title)),
          ])
        : _vm._e(),
      _vm.descriptionDefault || _vm.description
        ? _c("p", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.descriptionDefault || _vm.description)),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }